import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  static get targets() {
    return ["field"];
  }

  connect() {
    this._removeTemplateStyle();
    M.Datepicker.init(this.fieldTarget, this.options);
  }

  // Materialize's template hides the clear button with an inline style, which the
  // Content-Security-Policy blocks. The style only matters without showClearBtn: with it,
  // as below, Materialize shows the button again through the CSSOM.
  _removeTemplateStyle() {
    M.Datepicker._template = M.Datepicker._template.replace(" style=\"visibility: hidden;\"", "");
  }

  get options() {
    return {
      minDate: new Date(this.fieldTarget.dataset.minDate),
      maxDate: new Date(this.fieldTarget.dataset.maxDate),
      defaultDate: new Date(this.fieldTarget.dataset.defaultDate),
      setDefaultDate: true,
      showClearBtn: true,
    };
  }
}
